import { render, staticRenderFns } from "./ConvertAppToDeal.vue?vue&type=template&id=2b297fb3&scoped=true"
import script from "./ConvertAppToDeal.vue?vue&type=script&lang=js"
export * from "./ConvertAppToDeal.vue?vue&type=script&lang=js"
import style0 from "./ConvertAppToDeal.vue?vue&type=style&index=0&id=2b297fb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b297fb3",
  null
  
)

export default component.exports